import { CLASS_NAME } from 'constants/class-names'
import { Nullable } from 'constants/types'
import { LeadVideoComponent } from './lead-video.component'
import { isMobile } from 'utils/system/device'
import { PlaylistStore } from './store'

const {
    videoPlaylist: { videoCentre: videoCentreClass }
} = CLASS_NAME

export class VideoCentreComponent extends LeadVideoComponent {
    protected autoplay: 1 | 0 = isMobile() ? 0 : 1

    /**
     * Get the video centre section element
     *
     * @return {Nullable<HTMLElement>}
     */
    protected get playlistSection(): Nullable<HTMLElement> {
        return this.getElement(`.${videoCentreClass._}`)
    }

    /**
     * Get the top element
     *
     * @return {Nullable<HTMLHeadingElement>}
     */
    private get videoCentreTitle(): Nullable<HTMLHeadingElement> {
        return this.getElement<HTMLHeadingElement>(`.${videoCentreClass.title}`)
    }

    /**
     * Handle the Event for player change
     */
    protected onPlay(): void {
        super.onPlay()
        const leadVideo = PlaylistStore.getInstance().playlist

        if (this.player.index !== leadVideo.currentIndex) {
            PlaylistStore.getInstance().removeNowPlaying()
        }
    }

    /**
     * User clicks an item
     *
     * @param {string} playlistId
     * @param {number} index
     */
    public onClick(playlistId: string, index: number): void {
        if (index < 0) {
            return
        }

        PlaylistStore.getInstance().removeNowPlaying()

        // Clicked same video
        if (
            PlaylistStore.getInstance().playlist.playlistId === playlistId &&
            index === this.player.index
        ) {
            PlaylistStore.getInstance().playlist.addNowPlaying(index)
            return
        }

        // Scroll to the player
        if (this.videoCentreTitle) {
            this.videoCentreTitle.scrollIntoView(true)
        }

        super.onClick(playlistId, index)
    }

    /**
     * Resize list height if it needs
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected resizeQueueListHeight(): void {}
}
